import { createElement } from 'react'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { PreferencesLegacyIframe } from '@admin/preferences/PreferencesLegacyIframe'

export const Route = createFileRoute('/_auth/preferences/documents')({
  component: RouteComponent,
  beforeLoad: ({ context: { scopedEnablements } }) => {
    if (!scopedEnablements.global().hasStandardEnablement('DocumentTemplate', 'MANAGE')) {
      throw redirect({
        to: '/403',
        replace: true,
      })
    }
  },
})

function RouteComponent() {
  return createElement(PreferencesLegacyIframe, { name: 'documents' })
}
